// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__n3eqn","reportBodyText":"style__reportBodyText__J3+Yy"};